import React from 'react'
import cx from 'classnames'
import { Icon } from '@components/UI'

import {
  useRecordingPlaybackState,
  useRecordingPlaybackStateObserver
} from '../hooks'

const RecordingOverlay = () => {
  const { status, loading } = useRecordingPlaybackState()
  const playbackStateObserverRef = useRecordingPlaybackStateObserver()

  const getPlayButtonIconName = () => {
    if (loading) return 'loading spinner'
    return status === 'IDLE' ? 'play' : 'pause'
  }

  return (
    <div className='gp-Recording-overlay'>
      <button
        className={cx('ui gp-button interactive circular-btn', {
          'is-active': loading || status === 'IDLE'
        })}
        onClick={() => {
          if (loading) return

          status === 'IDLE'
            ? playbackStateObserverRef.current.play()
            : playbackStateObserverRef.current.pause()
        }}
      >
        <Icon name={getPlayButtonIconName()} />
      </button>
    </div>
  )
}

export default RecordingOverlay
